import { Component, Input } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import {
  transformName,
  getSeverityColor,
  getSeverityDashOffset,
  getSeverityValue,
  transformSeverityForDisplay,
} from '../../../utils/severity.utils';

@Component({
  selector: 'app-dialog-wrapper',
  templateUrl: './dialog-wrapper.component.html',
  styleUrls: ['./dialog-wrapper.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule],
})
export class DialogWrapperComponent {
  @Input() title: string = '';
  @Input() severity: string | null = null;

  constructor(private dialogRef: MatDialogRef<DialogWrapperComponent>) {}

  close(): void {
    this.dialogRef.close();
  }

  transformName = transformName;
  getSeverityColor = getSeverityColor;
  getSeverityDashOffset = getSeverityDashOffset;
  getSeverityValue = getSeverityValue;

  getSeverityDisplayText(severity: string): string {
    return transformSeverityForDisplay(severity);
  }
}
